import { I18N } from 'aurelia-i18n';
import { State } from '../../../services/global-state';
import { DigitalWalletSettings, DigitalWalletType } from '..';

export class ApplePaySettings extends DigitalWalletSettings {
	version: number;
	acceptsCredit: boolean;
	acceptsDebit: boolean;
	supportedNetworks: string[];
	totalAmount?: string;
	totalLabel?: string;
	totalType?: ApplePayJS.ApplePayLineItemType;
	countryCode?: string;
	currencyCode?: string;
	// recurring request specific
	recurringAmount?: string;
	recurringLabel?: string;
	paymentDescription?: string;
	paymentTiming?: ApplePayJSV14.ApplePayPaymentTiming;
	recurringPaymentStartDate?: Date;
	recurringPaymentEndDate?: Date;
	recurringPaymentIntervalUnit?: ApplePayJSV14.ApplePayRecurringPaymentDateUnit;
	recurringPaymentIntervalCount?: number;
	billingAgreement?: string;
	mangementURL?: string;
	// deferred request specific
	deferredPaymentDate?: Date;

	constructor(protected i18n: I18N, protected globalState: State) {
		super(i18n, globalState, DigitalWalletType.ApplePay);
	}

	// version 2 includes all cards Payrazr accepts
	// we are using version 3 to match imported @types/applepayjs and stay aligned with channels
	// https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentrequest/1916122-supportednetworks
	hasValidVersion(): boolean {
		return this.version && !isNaN(this.version) && this.version > 0;
	}

	validate(errors: any) {
		if (!this.acceptsCredit && !this.acceptsDebit) {
			errors.push(this.i18n.i18next.t('merchantMustAcceptDebitOrCreditCards', 'Merchant must accept Debit or Credit cards'));
		}

		if (!this.supportedNetworks || this.supportedNetworks.length === 0) {
			errors.push(this.i18n.i18next.t('invalidNetowrks', 'Invalid networks') + `: a valid network is required`);
		}
	}
}
